import { Empleador } from "@/interfaces/Empleador";
import { AxiosResponse } from "axios";
import axios from "./axios";

export const create = async (empleador: Empleador): Promise<AxiosResponse> =>
  await axios.put("/create", empleador);

export const getByGCorp = async (gcorp: string): Promise<AxiosResponse> =>
  await axios.get(`/getbygcorp?gcorp=${gcorp}`);

export const getAll = async (): Promise<AxiosResponse> =>
  await axios.get("/getall");

export const getByUsername = async (username: string): Promise<AxiosResponse> =>
  await axios.get(`/getbyusername?username=${username}`);
